import { makeVar } from '@apollo/client';

export const defaultLeasingInterest = {
  interestTypeId: null,
  interestTypeName: '',
  interestTypeCode: '',
  currencyId: null,
  currencyCode: '',
  periodicity: 0,
  isFixed: false
};

export const leasingInterestModalVar = makeVar({ open: false, item: defaultLeasingInterest });
